//GENERAL COLORS
export const WHITE = "#fff";
export const TEXT_COLOR = "#7d7d7d";
export const WHATS_APP_COLOR = "#25d366";

//GRUPO KRAUSE COLORS
export const HEADER_TITLE_COLOR = "#11301a";
export const PRIMARY_BTN_GK = "#266132";
export const SECONDARY_BTN_GK = "#266132";
export const TITLE_COLOR_GK = "#095225";
export const ICON_COLOR_GK = "#093015";
export const FADE_BG_GK =
  "linear-gradient(180deg,rgba(10, 57, 25, 0) 0%, rgba(10, 57, 25, 0.42) 37%, rgba(10, 57, 25, 0.83) 68%, rgba(10, 57, 25, 0.94) 87%, rgba(10, 57, 25, 1) 100%)";

export const BOX_SHADOW_GK = "5px 5px 0px -1px rgba(38, 97, 50, 0.91)";
export const LIGHT_BG_GK = "#F1FBF1";
export const FOOTER_BG_GK = "#F7F7F7";

//FUNERARIA COLORS
export const PRIMARY_BTN_FK = "#D8B27D";
export const SECONDARY_BTN_FK = "#D8B27D";
export const TITLE_COLOR_FK = "#D3A149";
export const ICON_COLOR_FK = "#304E32";
export const FADE_BG_FK =
  "linear-gradient(180deg,rgba(119, 85, 36, 0) 0%, rgba(119, 85, 36, 0.42) 37%, rgba(119, 85, 36, 0.83) 68%, rgba(119, 85, 36, 0.94) 87%, rgba(119, 85, 36, 1) 100%)";
export const LIGHT_BG_FK = "#F7EFE4";
export const FOOTER_BG_FK = "#F7EFE4";

//MEMORIAL COLORS
export const PRIMARY_BTN_MK = "#687E75";
export const SECONDARY_BTN_MK = "#687E75";
export const TITLE_COLOR_MK = "#465249";
export const ICON_COLOR_MK = "#C8A4AD";
export const FADE_BG_MK =
  "linear-gradient(180deg,rgba(104, 126, 117, 0) 0%, rgba(104, 126, 117, 0.42) 37%, rgba(104, 126, 117, 0.83) 68%, rgba(104, 126, 117, 0.94) 87%, rgba(104, 126, 117, 1) 100%)";
export const LIGHT_BG_MK = "#EBF5EC";
export const FOOTER_BG_MK = "#EBF5EC";

//ASSISTENCIAL COLORS
export const PRIMARY_BTN_KA = "#DF2D51";
export const TITLE_COLOR_KA = "#00937D";
export const SUB_TITLE_COLOR_KA = "#CA7E57";
export const ICON_COLOR_KA = "#E97444";
export const FADE_BG_KA =
  "linear-gradient(180deg,rgba(130, 81, 56, 0) 0%, rgba(130, 81, 56, 0.42) 37%, rgba(130, 81, 56, 0.83) 68%, rgba(130, 81, 56, 0.94) 87%, rgba(130, 81, 56, 1) 100%)";
export const BOX_SHADOW_KA = "5px 5px 0px -1px #00937D";
export const LIGHT_BG_KA = "#FCEFE6";
export const FOOTER_BG_KA = "#FCEFE6";

//MAIS QUE PET COLORS
export const PRIMARY_BTN_PET = "#11956B";
export const TITLE_COLOR_PET = "#6E4329";
export const ICON_COLOR_PET = "#E36E2D";
export const FADE_BG_PET =
  "linear-gradient(180deg,rgba(110, 67, 39, 0) 0%, rgba(110, 67, 39, 0.42) 37%, rgba(110, 67, 39, 0.83) 68%, rgba(110, 67, 39, 0.94) 87%, rgba(110, 67, 39, 1) 100%)";
export const LIGHT_BG_PET = "#FCF5F1";
export const FOOTER_BG_PET = "#FCF5F1";

//PEQUENOS COMETAS COLORS
export const PRIMARY_BTN_COMETAS = "#EEB53A";
export const TITLE_COLOR_COMETAS = "#90B4CC";
export const ICON_COLOR_COMETAS = "#EEB53A";
export const FADE_BG_COMETAS =
  "linear-gradient(180deg,rgba(144, 180, 204, 0) 0%, rgba(144, 180, 204, 0.30) 37%, rgba(144, 180, 204, 0.70) 68%, rgba(144, 180, 204, 0.90) 87%, rgba(144, 180, 204, 1) 100%)";
export const LIGHT_BG_COMETAS = "#F2F2F2";
export const FOOTER_BG_COMETAS = "#F2F2F2";
